import React, { useEffect, useRef } from "react";

/** Adds fade-in on scroll via IntersectionObserver to children with className "fade-up" */
export const FadeUpGroup = ({ children, className = "" }) => {
    const ref = useRef(null);
    useEffect(() => {
        const root = ref.current;
        if (!root) return;
        const items = root.querySelectorAll(".fade-up");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        items.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);
    return (
        <div ref={ref} className={className}>
            {children}
        </div>
    );
};

export default FadeUpGroup;
